import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setToolGuideBucket,
  setToolGuideStep,
  setToolGuideRole,
} from "../../store/slices/Sidebar/ToolGuideSlice";

/**
 * Lightweight Tool Guide path sync.
 * Does not change business logic — only updates Explorer-style path.
 *
 * @param {string} bucketName - e.g. "Response Received" or "Project Requests"
 * @param {string} roleKey - "L3" (sales), "L4_PM" (operations manager), or "L4_OPS" (operations person)
 */
export default function useToolGuideSync(bucketName, roleKey = "L3") {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session?.session);
  const employees = useSelector((state) => state.employees?.employees);

  const syncToolGuideStep = useCallback(
    (stepId) => {
      if (!bucketName) return;

      const authLevel = String(
        session?.auth ||
          (typeof localStorage !== "undefined" ? localStorage.getItem("auth") : "") ||
          ""
      )
        .trim()
        .toUpperCase();

      const normalizedRole = String(roleKey || "L3").trim().toUpperCase();

      const email =
        typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
      const emp = Array.isArray(employees)
        ? employees.find((e) => e.EmpEmail === email)
        : null;
      const roles = Array.isArray(emp?.customRoles)
        ? emp.customRoles
        : typeof emp?.customRoles === "string"
          ? [emp.customRoles]
          : typeof localStorage !== "undefined" && localStorage.getItem("Roles")
            ? [localStorage.getItem("Roles")]
            : [];
      const roleList = roles.map((r) => String(r).trim().toLowerCase());
      const isPm = roleList.some((r) => r === "project manager" || r.includes("project manager"));
      const isOps = roleList.some((r) => r === "operations" || r.includes("operations"));

      if (normalizedRole === "L3") {
        if (authLevel !== "L3") return;
      } else if (normalizedRole === "L4_PM") {
        if (authLevel !== "L4" || !isPm) return;
      } else if (normalizedRole === "L4_OPS") {
        if (authLevel !== "L4" || !isOps || isPm) return;
      } else {
        return;
      }

      dispatch(setToolGuideRole(normalizedRole));
      dispatch(
        setToolGuideBucket({
          bucketName,
          roleKey: normalizedRole,
          openPanel: true,
        })
      );
      if (stepId) {
        dispatch(setToolGuideStep({ stepId, openPanel: true }));
      }
    },
    [dispatch, session, bucketName, roleKey, employees]
  );

  return { syncToolGuideStep };
}
